import Rails from '@rails/ujs'
Rails.start()

import Turbolinks from 'turbolinks'
Turbolinks.start()

import LocalTime from "local-time"
LocalTime.start()

import "controllers"
import "homenew"
